import { Wrapper } from 'components/Pages/Wine/View/Main/Content/ColumnLeft/_styles'
import Description from '../Description'

const ColumnLeft = () => {
  return (
    <Wrapper>
      <Description />
    </Wrapper>
  )
}

export default ColumnLeft
